import axios from 'axios';
import { Browser } from '@capacitor/browser';

export const login = async () =>
  await Browser.open({
    url: `${process.env.VUE_APP_LOGIN_DOMAIN}/login?client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_FRONTEND_DOMAIN}/login&scope=openid+profile+email+aws.cognito.signin.user.admin&response_type=code`,
    presentationStyle: 'popover',
    windowName: '_self',
  });

export const register = async () =>
  await Browser.open({
    url: `${process.env.VUE_APP_LOGIN_DOMAIN}/signup?client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_FRONTEND_DOMAIN}/login&scope=openid+profile+email+aws.cognito.signin.user.admin&response_type=code`,
    presentationStyle: 'popover',
    windowName: '_self',
  });

export const forgotPassword = async () =>
  await Browser.open({
    url: `${process.env.VUE_APP_LOGIN_DOMAIN}/forgotPassword?client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_FRONTEND_DOMAIN}/login&scope=openid+profile+email+aws.cognito.signin.user.admin&response_type=code`,
    presentationStyle: 'popover',
    windowName: '_self',
  });

export const logout = () =>
  Browser.open({
    url: `${process.env.VUE_APP_FRONTEND_DOMAIN}/logout?client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&logout_uri=${process.env.VUE_APP_FRONTEND_DOMAIN}/logout`,
    presentationStyle: 'popover',
    windowName: '_self',
  });

export const fetchAccessTokens = (code: string) =>
  axios.post(
    `${process.env.VUE_APP_LOGIN_DOMAIN}/oauth2/token`,
    `client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&grant_type=authorization_code&redirect_uri=${process.env.VUE_APP_FRONTEND_DOMAIN}/login&code=${code}`,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

export const fetchRefreshedAccessTokens = (refreshToken: string) =>
  axios.post(
    `${process.env.VUE_APP_LOGIN_DOMAIN}/oauth2/token`,
    `client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&grant_type=refresh_token&refresh_token=${refreshToken}`,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  );

export const fetchUserInfo = (token: string) =>
  axios.get(`${process.env.VUE_APP_LOGIN_DOMAIN}/oauth2/userInfo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const isTokenExpired = (token: string) =>
  Date.now() >= JSON.parse(atob(token.split('.')[1])).exp * 1000;

export const tokenExpiresInFiveMins = (token: string) =>
  JSON.parse(atob(token.split('.')[1])).exp * 1000 - Date.now() <= 300000;
